const RCSLogo = require("src/Assets/Images/rcs_logo.svg");
const NovaLogo = require("src/Assets/Images/NovaLogo.svg");
export const getPartnerInfo = (domainName: string) => {
  switch (domainName) {
    case "funpassplus":
      return {
        name: "FunPass+",
        logo: RCSLogo,
      };
    default:
      return {
        name: "Nova",
        logo: NovaLogo,
      };
  }
};
export type domainObject = {
  name: string;
  logo: string;
};
